export function getDailyExerciseSummary(
  assetType: string,
  questionCount: number
): string {
  const isOne = questionCount === 1;

  const summaries: Record<string, string> = {
    SINGLE_QUESTION: 'Answer the question',
    SINGLE_QUESTION_PHOTO: 'Look at the photo then answer the question',
    SINGLE_QUESTION_VIDEO: 'Watch the video then answer the question',

    MULTI_QUESTION: 'Answer the questions',
    MULTI_QUESTION_PHOTO: 'Look at the photo then answer the questions',
    MULTI_QUESTION_VIDEO: 'Watch the video then answer the questions',
  };

  // Build the lookup key
  let key = isOne ? 'SINGLE_QUESTION' : 'MULTI_QUESTION';

  if (assetType === 'PHOTO') key += '_PHOTO';
  else if (assetType === 'VIDEO') key += '_VIDEO';

  // Return the matched summary (default to base SINGLE_QUESTION/MULTI_QUESTION)
  return summaries[key] || summaries[isOne ? 'SINGLE_QUESTION' : 'MULTI_QUESTION'];
}
